import { Box, useMediaQuery } from "@material-ui/core";
import { useEffect, useState } from "react";

import Filters from "@/common/components/MapLandingPage/Filters/Filters";
import { useStyles } from "@/common/components/MapLandingPage/MapView/MapViewStyles";
import { RightUnitDrawer } from "@/common/components/MapLandingPage/RightUnitDrawer";
import { useDispatch, useSelector } from "@/store";
import { mapSelectors, setSelectedUnit } from "@/store/map/slice";

import { drawerWidth } from "../RightUnitDrawer/RightUnitDrawerStyles";
import { SearchMap } from "../SearchMap/SearchMap";


const MapView: React.FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
    const selectedUnit = useSelector(mapSelectors.getSelectedUnit);

    useEffect(() => {
        setIsDrawerOpen(!!selectedUnit);
    }, [selectedUnit]);

    const handleClose = () => {
        dispatch(setSelectedUnit(null));
    };

    //If the screen is greater than twice the drawer width, shift the map along with its controls
    //Else just overlay the drawer on top of the map on opening.
    const isGreaterThanDrawerWidth = useMediaQuery(`(min-width:${2 * drawerWidth}px)`);

    return (
        <Box className={classes.root}>
            <RightUnitDrawer isDrawerOpen={isDrawerOpen} handleClose={handleClose} />
            <Filters />
            <div className={isDrawerOpen && isGreaterThanDrawerWidth ? classes.mapShift : classes.mapNoShift}>
                <SearchMap />
            </div>
        </Box>
    );
};

export default MapView;
